/* eslint-disable react/prop-types */
import React, {
  createContext, useState, useContext, useMemo,
} from 'react';

const HeaderContext = createContext();

export function HeaderProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [overQuota, setOverQuota] = useState(null);
  const [overWorkspaceQuota, setOverWorkspaceQuota] = useState(null);

  const contextValue = useMemo(
    () => ({
      notifications,
      setNotifications,
      overQuota,
      setOverQuota,
      overWorkspaceQuota,
      setOverWorkspaceQuota,
    }),
    [notifications, overQuota, overWorkspaceQuota],
  );

  return (
    <HeaderContext.Provider value={contextValue}>
      {children}
    </HeaderContext.Provider>
  );
}

export const useNotifications = () => useContext(HeaderContext);
